module.exports = __webpack_public_path__ + "static/media/beingcrypto.1c9692ac.png";